
import { Component, Vue, Watch } from "vue-property-decorator";
import Nav from "@/components/nav/index.vue";
import Footer from "@/components/footer/index.vue";
import Recruit from "@/components/recruit/index.vue";

@Component({
  components: {
    Nav,
    Recruit,
    Footer,
  },
})
export default class Home extends Vue {
  navHeight = this.$store.state.navCommonHeight;
  footerHeight = this.$store.state.footerHeight;
  componentKey = 0  

  mounted() {
    const categoryId = window.sessionStorage.getItem("categoryId");
    if (categoryId) {
      return;
    } else {
      // 设置默认分类
      window.sessionStorage.setItem("categoryId", "-1");
    }
  }

  // 强制更新页面渲染
  @Watch('$route')
  onChangeRoute(newValue: string, oldValue: string) {
    if (newValue) {
      this.componentKey ++
    }
  }
}
